import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useGlobalErrorStore, useRouterHistory } from 'scbk-services';
import { IdVerificationRouteData, useRemoteIdvCheck } from 'scbk-shared-module/modules/Identity';
import { BottomButtons, LineIcon, ProcessList, ProcessListItem } from 'scbk-ui-web';
import { useAutVrfAddActivateIdVerification } from '../hooks/api/autVrfAdditionalHooks';
import { AutVrfAddActivateIdVerificationResponse } from '../types/api/autVrfAddActivateIdVerification';

const AdditionalIdVerificationComponent: React.FC = () => {
  const { t } = useTranslation();

  const { currentRoute, stack } = useRouterHistory.getState();

  const { goIdVerification } = useRemoteIdvCheck();

  const { request: activateIdVerification } = useAutVrfAddActivateIdVerification({
    onError: (error) => {
      useGlobalErrorStore.getState().setErrorInfo({ ...error, title: `!!!!${error.code}` });
    },
  });

  const nextHandler = useCallback(async () => {
    /* 화면 진입시 설정한 routeData 조회 */
    const routeEntry = stack.find((v) => v.id === currentRoute?.id);
    const routeData = { ...routeEntry?.routeData };

    /* 비대면실명인증(신분증 + 안면인식) 을 위한 초기화 */
    const result: AutVrfAddActivateIdVerificationResponse | undefined =
      await activateIdVerification();

    const idVerificationParams: IdVerificationRouteData = {
      bizType: result?.bizType ?? 'IDCM',
      nextUrl: currentRoute?.id,
      productCode: result?.prdctCd,
      productName: result?.prdctNm,
      reqBranchCode: '100',
      reqBranchName: '영업부',
      paramJsonString: JSON.stringify(routeData),
      tradNo: result?.tradNo,
      custNo: result?.custNo,
      isForceFace: 'Y',
      isForceVideo: 'N',
      isCommonEntered: 'Y',
    };

    goIdVerification(idVerificationParams);
  }, []);

  return (
    <>
      <h2 className="page-heading-title mb-3">
        <Trans
          i18nKey="AdditionalComponent.118"
          components={[<span className="block md:inline md:mr-1"></span>]}
        >
          <span className="block md:inline md:mr-1">안전한 금융거래를 위해 다음과 같이</span>
          신분증을 제출해 주세요
        </Trans>
      </h2>

      <ProcessList>
        <ProcessListItem
          key={`process-0`}
          icon={<LineIcon icoName="ico-id-card" icoColor="bg-icon-primary-04" type="lg" />}
          title={t('AdditionalComponent.119', '신분증 제출 방법 선택')}
          desc={t('AdditionalComponent.120', '신분증 촬영 또는 모바일 신분증')}
        />
        <ProcessListItem
          key={`process-1`}
          icon={<LineIcon icoName="ico-face-id" icoColor="bg-icon-primary-04" type="lg" />}
          title={t('AdditionalComponent.121', '안면인식')}
          desc={t('AdditionalComponent.122', '제출된 신분증과 얼굴 일치여부 확인')}
        />
      </ProcessList>

      <BottomButtons
        buttons={[
          {
            label: t('AdditionalComponent.123', '신분증 제출'),
            onClick: () => {
              nextHandler();
            },
            Variants: 'primary',
          },
        ]}
      />
    </>
  );
};

export default AdditionalIdVerificationComponent;
